import React, { Suspense } from 'react';
import { Outlet, useMatches, useNavigate } from 'react-router-dom';
import { Skeleton } from 'antd';

import ContextBar, { ContextBarTabs } from '../common/ContextBar';
import { useCurrentUser } from '../../contexts/CurrentUserContext';
import { leafHandle } from '../../config/routeHandles';
import { isAdmin } from '../../utils';

// Every tab is for everyone. How keepr is built (the atlases, the
// engineering change log, the line counts) lives in the admin portal.
const NAV_ITEMS = [
	{ key: 'guides', label: 'Guides', path: '/docs' },
	{ key: 'whats-new', label: 'What\u2019s new', path: '/docs/whats-new' },
	// The videos (KPR-1923).
	{ key: 'showcase', label: 'Showcase', path: '/docs/showcase' },
];

/** The same answer RequireAdmin gives, for deciding which tabs to offer. */
export function useIsAdmin() {
	const { user } = useCurrentUser();
	return user ? Array.isArray(user.roles) && user.roles.includes('admin') : isAdmin();
}

/**
 * Shell for the /docs portal: the one context bar, the section tabs, and an
 * Outlet. Sits beside /admin in the rail and is built the same way.
 */
export default function DocsLayout() {
	const navigate = useNavigate();
	const items = NAV_ITEMS;
	// Each page's route names its tab (`docsSection`, config/routeHandles).
	const section = leafHandle(useMatches()).docsSection;
	const activeKey = (items.find(item => item.key === section) || items[0]).key;

	return (
		<>
			<ContextBar title='Documentation'>
				{items.length > 1 ? (
					<ContextBarTabs
						aria-label='Documentation sections'
						items={items.map(({ key, label }) => ({ key, label }))}
						activeKey={activeKey}
						onChange={key => navigate(items.find(item => item.key === key).path)}
					/>
				) : null}
			</ContextBar>
			<Suspense fallback={<Skeleton active paragraph={{ rows: 8 }} />}>
				<Outlet />
			</Suspense>
		</>
	);
}
